(() => {
  const isLinkBio =
    /[?&](links|bio)=1(?:&|$)/.test(window.location.search) ||
    window.location.hash === "#links";

  if (!isLinkBio) return;

  const showLinkBio = async () => {
    try {
      const response = await fetch("/?section_id=mofee-social-links");
      if (!response.ok) return;

      const html = await response.text();
      if (!html.includes("mofee-social-page")) return;

      const main = document.getElementById("MainContent") || document.querySelector("main");
      if (!main) return;

      document.documentElement.classList.add("link-bio-mode");
      document.title = "MOFEE Links | Shop Yoga Activewear";
      main.innerHTML = html;

      document.querySelectorAll(".announcement, .site-header, .site-footer").forEach((item) => {
        item.hidden = true;
      });
    } catch {
      document.documentElement.classList.remove("link-bio-mode");
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", showLinkBio, { once: true });
  } else {
    showLinkBio();
  }
})();

document.querySelectorAll(".product-form").forEach((form) => {
  const variantInput = form.querySelector('input[name="id"]');
  const productJson = form.querySelector('[type="application/json"]');

  if (!variantInput || !productJson) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch {
    return;
  }

  const optionInputs = Array.from(form.querySelectorAll("[data-product-option]"));

  const updateVariant = () => {
    const selectedOptions = optionInputs.map((input) => input.value);
    const variant = product.variants.find((item) => {
      return item.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!variant) return;

    variantInput.value = variant.id;
    const submit = form.querySelector("[data-product-submit]");
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }
  };

  optionInputs.forEach((input) => input.addEventListener("change", updateVariant));
});
